import LinkButton, { LinkButtonProps } from "common/components/LinkButton";

import styles from "../../styles/TabButton.module.less";

type TabButtonProps = { active: boolean; label: string } & LinkButtonProps;

const TabButton = (props: TabButtonProps) => {
  const { active, className, label, ...other } = props;

  const classNames = `${styles.container} ${className} ${active && styles.active}`;

  return (
    <LinkButton className={classNames} {...other}>
      {label}
    </LinkButton>
  );
};

export default TabButton;
